var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pdf-wrapper",
      on: {
        contextmenu: function ($event) {
          $event.preventDefault()
        },
        dragstart: function ($event) {
          $event.preventDefault()
        },
        selectstart: function ($event) {
          $event.preventDefault()
        },
        keydown: function ($event) {
          $event.preventDefault()
          return _vm.handleKeyDown.apply(null, arguments)
        },
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.imageList.length > 0
        ? _c(
            "div",
            { staticClass: "pdf-image-container" },
            _vm._l(_vm.imageList, function (img, index) {
              return _c("div", {
                key: index,
                staticClass: "pdf-page-container",
                style: { backgroundImage: `url(${img})` },
              })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "error-tip" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { "aria-hidden": "true" } },
      [
        _c("div", { attrs: { id: "anti-debugger" } }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=",
            onerror:
              "(() => { if (window.devtools) { window.location.reload(); } })();",
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }